export class RdStationDeleteModalController {
    static $inject = ['close', 'configurations', 'onDelete'];
    constructor(close, configurations, onDelete) {
        this.close = close;
        this.configurations = configurations;
        this.onDelete = onDelete;
    }
    async onContinue() {
        try {
            this.onDelete();
        }
        catch (err) {
            console.error(err);
        }
        this.close();
    }
    onCancel() {
        this.close();
    }
}
RdStationDeleteModalController.$inject = ['close', 'configurations', 'onDelete'];
